// utils/apiUtils.ts
import { API_CONFIG } from "@/config/api";

export const getApiBaseUrl = (): string => {
  const apiUrl = API_CONFIG.URL;

  // In development, if the frontend is served over HTTPS but API is HTTP,
  // this will cause mixed content issues
  if (process.env.NODE_ENV === "development") {
    const isCurrentHttps = window.location.protocol === "https:";
    const isApiHttp = apiUrl.startsWith("http:");

    if (isCurrentHttps && isApiHttp) {
      console.warn("⚠️ Mixed Content Warning:", {
        frontend: "HTTPS",
        api: "HTTP",
        solution:
          "Either serve the frontend over HTTP or run the backend with HTTPS",
      });
    }
  }

  return apiUrl;
};

export const checkApiConnection = async (): Promise<boolean> => {
  try {
    const apiUrl = getApiBaseUrl();
    const response = await fetch(`${apiUrl}/health`, {
      method: "GET",
      mode: "cors",
    });
    return response.ok;
  } catch (error) {
    console.error("API connection check failed:", error);
    return false;
  }
};

export const getApiStatus = async (): Promise<{
  connected: boolean;
  error?: string;
  details?: any;
}> => {
  try {
    const apiUrl = getApiBaseUrl();

    const response = await fetch(`${apiUrl}/health`, {
      method: "GET",
      mode: "cors",
    });

    if (response.ok) {
      return { connected: true };
    } else {
      return {
        connected: false,
        error: `API returned status ${response.status}`,
        details: { status: response.status, statusText: response.statusText },
      };
    }
  } catch (error: any) {
    let errorMessage = "Unknown error";
    let details: any = { error };

    if (error.message?.includes("Mixed Content")) {
      errorMessage =
        "Mixed content blocked - frontend is HTTPS but API is HTTP";
    } else if (error.message?.includes("fetch")) {
      errorMessage = "Network request failed - API server may be down";
    } else {
      errorMessage = error.message || "Connection failed";
    }

    return {
      connected: false,
      error: errorMessage,
      details,
    };
  }
};

